export const CONSENT_DATOS = `AUTORIZACIÓN PARA EL TRATAMIENTO DE DATOS PERSONALES

En cumplimiento de la Ley 1581 de 2012 y el Decreto 1377 de 2013, autorizo de manera libre, previa, expresa e informada el tratamiento de mis datos personales, incluyendo datos sensibles relacionados con mi estado de salud, por parte del equipo médico del Dr. David Duque.

FINALIDADES:
1. Gestión de la historia clínica electrónica conforme a la Resolución 1995 de 1999 y la Ley 2015 de 2020.
2. Seguimiento y control de mi condición de linfedema.
3. Comunicaciones relacionadas con mi atención médica.

DERECHOS DEL TITULAR:
- Conocer, actualizar y rectificar sus datos personales.
- Solicitar prueba de la autorización otorgada.
- Ser informado sobre el uso que se ha dado a sus datos.
- Revocar la autorización y/o solicitar la supresión del dato.
- Acceder de forma gratuita a sus datos personales.

Los datos serán conservados por un mínimo de 15 años conforme a la Resolución 839 de 2017.`;

export const CONSENT_FOTOGRAFIA = `CONSENTIMIENTO PARA REGISTRO FOTOGRÁFICO CLÍNICO

Autorizo la toma de fotografías clínicas de mi condición de linfedema con fines de:
1. Documentación y seguimiento de mi evolución clínica.
2. Registro en mi historia clínica electrónica.
3. Comparación objetiva del progreso del tratamiento.

Las fotografías forman parte integral de la historia clínica y están protegidas por la Ley 1581 de 2012 (Habeas Data) y la Resolución 1995 de 1999.

Las imágenes NO serán utilizadas para fines publicitarios, académicos o de investigación sin una autorización adicional expresa y por escrito.`;

export const CONSENT_PROCEDIMIENTO = `CONSENTIMIENTO INFORMADO PARA PROCEDIMIENTO

He sido informado/a por mi médico tratante sobre:
1. La naturaleza de mi condición (linfedema) y su pronóstico.
2. Las opciones de tratamiento disponibles, incluyendo la Terapia Descongestiva Compleja (TDC).
3. Los riesgos y beneficios del tratamiento propuesto.
4. Las alternativas de tratamiento.
5. Las consecuencias de no recibir tratamiento.

He tenido la oportunidad de hacer preguntas y estas han sido resueltas satisfactoriamente. Comprendo que puedo revocar este consentimiento en cualquier momento.`;
